
import React from 'react';
import PropTypes from 'prop-types';

import Schools from '../Schools/Container.jsx';

export default class SchoolsEnglishContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            schools: []
        };

    }

    componentWillMount() {
        this.setState({
            schools: this.props.schools
        });
    }


    render() {
        return (
            <Schools
                schools={this.state.schools} lang="en"
            />
        );
    }
}

SchoolsEnglishContainer.propTypes = {
    schools: PropTypes.array,
};